import { useState, useEffect } from 'react';
import { notify } from '../utils/utils';
import { AuthFetch, AuthFetchRecharge } from '../services/api';
import { useModal } from './useModal';

export const useChatOnline = () => {

    const mensajeDefault = {
        codPeticion: 0,
        mensaje: "",
        uidDestino: "",
        chatActivo: false
    }

    const [ mensaje, setMensaje ] = useState(mensajeDefault) //estado para los mensajes 
    const [ chat,setChat ] = useState({}); //estado para el chat en general
    const [ mensajes , setMensajes ] = useState([]) //listado de mensajes 
    const [ isOpenModalChat, openModalChat, closeModalChat ] = useModal();
    
    const limpiarMensaje = () =>  {
        setMensaje(mensajeDefault)
    }
    
    const guardarEditarMensaje= async () => { // guardado de un nuevo mensaje
        const response = await AuthFetchRecharge('/Notification/notifyWebMobile' ,{
                method: 'POST',
                body: JSON.stringify({
                    codPeticion: chat.codPeticion,
                    mensaje: mensaje.mensaje,
                    uidDestino: chat.uid,
                    chatActivo: mensaje.chatActivo || false
            }),
        });

        notify((response.isValid ? response.content : response.exceptions[0].description),(response.isValid ? 'success' : 'error') )
        
        if (response.isValid) {
            // obtenerChat(mensaje.codPeticion)
            // setMensaje(mensajeDefault)
        }
        obtenerChat(chat, false)

    }
    

    const obtenerChat = async (chatUltimo, abrirChat = true) => { //obtener chat (array de mensajes) por codPeticion de la recarga
        setChat(chatUltimo)
        
        const response = await AuthFetchRecharge(`/Notification/NotificationWeb/${chatUltimo.codPeticion}`) 
        if(response.isValid){
            setMensaje({
                codPeticion: 0,
                mensaje: "",
                uidDestino: "",
                chatActivo: response.content.length > 0 ?  response.content[response.content.length-1].activoChat : mensajeDefault
            })
            setMensajes(response.content)
            abrirChat && openModalChat()
        }else{
            setMensajes([])
            notify(response.exceptions[0].description, 'error');
        }
    }

    const editarValorMensaje = (key,value) =>{
        setMensaje(mensaje => {
            return {
                ...mensaje,
                [key]: value
            }
        });
    }    
    
    const editarValorChat = (key,value) =>{
        setChat(chat => {
            return {
                ...chat,
                [key]: value
            }
        });
    }  

    return { 
            chat,
            mensaje,
            mensajes,
            limpiarMensaje,
            obtenerChat,
            editarValorMensaje,
            guardarEditarMensaje,
            isOpenModalChat,
            openModalChat,
            closeModalChat,
        }
}